import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_buttonComponent = _resolveComponent("buttonComponent")!
  const _component_modalComponent = _resolveComponent("modalComponent")!

  return (_ctx.showModal)
    ? (_openBlock(), _createBlock(_component_modalComponent, {
        key: 0,
        id: _ctx.modal.id
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass([{ Modal__errorIcon: _ctx.modal.error, Modal__infoHandIcon: !_ctx.modal.error }])
          }, null, 2)
        ]),
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "Modal__heading",
              textContent: _toDisplayString(_ctx.modal.title)
            }, null, 8, _hoisted_2),
            _createElementVNode("div", {
              innerHTML: _ctx.modal.content
            }, null, 8, _hoisted_3),
            (_ctx.modal.btnInlineLabel)
              ? (_openBlock(), _createBlock(_component_buttonComponent, {
                  key: 0,
                  "btn-class": _ctx.modal.btnInlineStyle,
                  label: _ctx.modal.btnInlineLabel,
                  onButtonComponent: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleInlineAction()))
                }, null, 8, ["btn-class", "label"]))
              : _createCommentVNode("", true)
          ])
        ]),
        footer: _withCtx(() => [
          (_ctx.modal.btnSecondLabel)
            ? (_openBlock(), _createBlock(_component_buttonComponent, {
                key: 0,
                "btn-class": _ctx.modal.btnSecondStyle,
                "btn-type": 'button',
                label: _ctx.modal.btnSecondLabel,
                onButtonComponent: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeModal()))
              }, null, 8, ["btn-class", "label"]))
            : _createCommentVNode("", true),
          (_ctx.modal.btnLabel)
            ? (_openBlock(), _createBlock(_component_buttonComponent, {
                key: 1,
                "data-mainbtn": "",
                "btn-class": _ctx.modal.btnStyle,
                label: _ctx.modal.btnLabel,
                onButtonComponent: _ctx.btnAction
              }, null, 8, ["btn-class", "label", "onButtonComponent"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["id"]))
    : _createCommentVNode("", true)
}